import styled from 'styled-components/macro'

import { getToken, toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

import { VerticalDivider } from 'core/ui/components/divider/VerticalDivider'

import { screen } from 'legacy/styles/screen'

export const CardWrapper = styled.div`
  background-color: ${toCSSValue('color-background-primary')};
  border: ${getToken('border-thin')} solid ${toCSSValue('color-border')};
  border-radius: ${getToken('border-radius-s')};
  gap: ${getToken('spacing-4')};
`

export const DeadlineWrapper = styled.div`
  padding: ${getToken('spacing-4')};
  border-bottom: ${getToken('border-thin')} solid ${toCSSValue('color-border')};
`

export const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${getToken('spacing-4')};
  gap: ${getToken('spacing-6')};
`

export const StyledVerticalDivider = styled(VerticalDivider)`
  display: none;

  ${screen.md} {
    display: block;
  }
`
